import {
  Box,
  Card,
  Flex,
  Grid,
  GridCell,
  InfoIconWithTooltip,
  Separator,
  SubTitle,
  Text,
} from "@shared/primitive-components"
import { speedingStyles as styles } from "../../../styles"
import { SpeedingComponentProps } from "../../../types"
import { SpeedingChart, SpeedingDetails } from "."

const TooltipContent = (
  <Text css={styles.tooltipContent}>
    The percentage of your fleet&apos;s overall mileage that is spent speeding on a month by month basis. Click on each
    bar to view the speeding breakdown that month.
  </Text>
)

export const SpeedingOverTime = ({ periods, activePeriod, setActivePeriod, loading }: SpeedingComponentProps) => (
  <Card css={styles.marginBottom(4)}>
    <Box css={styles.fullWidth}>
      <Box>
        <Flex alignItems="center">
          <SubTitle>Speeding Over Time</SubTitle>
          <InfoIconWithTooltip content={TooltipContent} />
        </Flex>
        <Separator size="block" color="yellow" css={styles.marginBottom(4)} />
      </Box>
      <Grid css={styles.fullWidth}>
        <GridCell phone={12} desktop={activePeriod ? 8 : 12}>
          <SpeedingChart {...{ loading, periods, activePeriod, setActivePeriod }} />
        </GridCell>
        {activePeriod && (
          <GridCell phone={12} desktop={4} css={styles.paddingLeft(4)}>
            <SpeedingDetails {...{ periods, activePeriod }} />
          </GridCell>
        )}
      </Grid>
    </Box>
  </Card>
)
